var map = {
	"./1bit-shield.png": "7a6e",
	"./1bit-swords.png": "a537",
	"./bag.png": "d3c1",
	"./chest.png": "c0b3",
	"./chevron.png": "1cca",
	"./discord.png": "2cf2",
	"./exit.png": "e890",
	"./gq.png": "3bcd",
	"./grandquest.png": "7015",
	"./guild.png": "2453",
	"./leaderboards.png": "ed20",
	"./monokai-village/combat-shop.png": "d036",
	"./monokai-village/heros-trial.png": "dfa6",
	"./monokai-village/ht.png": "213f",
	"./monokai-village/monokai-village.png": "b46e",
	"./monokai-village/potions-shop.png": "f961",
	"./monokai-village/village-gate.png": "d512",
	"./people/adventurer.png": "291a",
	"./people/daelen.png": "25ab",
	"./people/even.png": "c98b",
	"./people/marco.png": "fba3",
	"./people/ninja.png": "2c59",
	"./reddit.png": "19ee",
	"./scroll.png": "b1f5",
	"./select-hand.png": "50ce",
	"./select-target.png": "1ef6",
	"./share-link.png": "0f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a233";